import React, { useEffect, useMemo, useState } from "react";
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap";
import { formContentContainer, loaderOverlay } from "../../Style/loaderOverly";
import { AvForm } from "availity-reactstrap-validation";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  createPageData,
  CommissioningClaimFormData,
} from "./CommissioningClaimFile";
import { LoaderCreatePage } from "../Loader/Loader";
import {
  DownloadPDFData,
  getRecords,
  saveRecords,
  formatNumber,
} from "../../services/api.service";
import { toast } from "react-toastify";
import TextAreaInput from "../../custom/components/TextArea-Input/TextAreaInput";
import CheckboxInput from "../../custom/components/CheckBox-Input/CheckboxInput";
import CommissioningClaimPDF from "./CommissioningApprovalPDF/CommissioningClaimPDF";

const CommissioningClaimView = () => {
  const breadcrumbItems = [];
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const { payload, navigatePage, headerName, createEndpoint, getEndpoint } =
    createPageData();
  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(CommissioningClaimFormData());
  const [fetchedData, setFetchedData] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [groupedItems, setGroupedItems] = useState({});
  const [formErrors, setFormErrors] = useState({});

  let serialNumber = 1;

  useEffect(() => {
    if (id) {
      getEditData(id);
    }
  }, []);

  useEffect(() => {
    if (fetchedData) {
      let data = fetchedData[0];

      const updatedListDetails = data?.installation_items?.map((item) => ({
        item_id: item?.item_id,
        buy_item_id: item?.buy_item_id,
        item_code: item?.item_code,
        buy_item_code: item?.buy_item_code,
        description: item?.buy_item_desc,
        uom: item.buy_item_uom,
        make_item_desc: item?.item_description,
        make_item_uom: item.uom,
        // stock_qty: item?.stock_qty,
        required_qty: item?.required_qty,
        assigned_qty: item?.assigned_qty,
        already_installed_qty: item?.already_installed_qty,
        installed_qty: item?.install_qty,
        type: item?.is_make_item ? 1 : 2,
        is_make_item: item?.is_make_item,
        is_active: item?.is_active,
        id: item.id,

        make_buy_name: item?.is_make_item
          ? item?.buyItem?.item_code + " (" + item?.makeItem?.item_code + ")"
          : item?.buyItem?.item_code,

        commissioning_claim_remark: item?.commissioning_claim_remark || "",
        commissioning_claim_by: item?.commissioning_claim_by || null,
        is_commissioning_item_claimed:
          item?.is_commissioning_item_claimed || false,
        installation_item_id: item?.installation_item_id || null,

        is_commissioning_item_paid: item?.is_commissioning_item_paid || false,
        commissioning_paid_by: item?.commissioning_paid_by || null,
        is_commissioning_paid: data?.is_commissioning_paid,
      }));

      setFormData((prevState) => ({
        ...prevState,
        inputData: {
          ...prevState.inputData,
          ...data,
          installation_items: updatedListDetails,
        },
      }));
    }
  }, [fetchedData]);

  const getEditData = async (Id) => {
    try {
      const projectId = JSON.parse(localStorage?.getItem("projectID"));
      const contractor_id = JSON.parse(localStorage.getItem("userDetails"))?.id;
      const payload = {
        modelName: "installations",
        whereCondition: {
          commissioning_id: id,
          project_id: projectId,
          is_completed: true,
          status: ["commissioning_completed", "installation_approved"],
        },
      };
      const responseData = await getRecords(payload, getEndpoint);

      if (responseData?.code == 1) {
        const data = responseData?.data;
        setFetchedData(data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  const FloatValue = (value) => {
    return parseFloat(value);
  };

  const filteredItems =
    formData?.inputData?.installation_items?.filter(
      (item) =>
        item?.item_code?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item?.buy_item_code?.toLowerCase().includes(searchQuery.toLowerCase()),
    ) || [];

  useEffect(() => {
    if (!filteredItems || filteredItems?.length === 0) {
      setGroupedItems({});
      return;
    }

    const grouped = filteredItems.reduce((acc, item) => {
      if (!acc[item.item_code]) {
        acc[item.item_code] = {
          makeItem: { ...item, unique_id: `${item.item_code}-${item.id}` },
          buyItems: [],
        };
      }

      if (item.buy_item_code) {
        acc[item.item_code].buyItems.push({
          ...item,
          unique_id: `${item.buy_item_code}-${item.id}`,
        });
      }

      return acc;
    }, {});

    setGroupedItems(grouped);
  }, [filteredItems]);

  const handleItemDetailInputChange = (e, itemCode) => {
    const { name, value } = e.target;

    setFormErrors((prevErrors) => {
      const newErrors = { ...prevErrors };

      // Initialize installation_items errors if not present
      if (!newErrors.installation_items) {
        newErrors.installation_items = {};
      }

      // Check if the item is claimed and the remark is empty
      if (
        formData?.inputData?.installation_items?.find(
          (item) => item.item_code === itemCode,
        )?.is_commissioning_item_claimed &&
        !value.trim()
      ) {
        newErrors.installation_items[itemCode] = {
          ...newErrors.installation_items[itemCode],
          commissioning_claim_remark: "commissioning claim remark is required",
        };
      } else {
        if (newErrors.installation_items[itemCode]) {
          delete newErrors.installation_items[itemCode]
            .commissioning_claim_remark;
        }
      }

      return newErrors;
    });

    setFormData((prev) => {
      const updatedDetails = prev.inputData.installation_items?.map((item) =>
        item.item_code === itemCode ? { ...item, [name]: value } : item,
      );

      return {
        ...prev,
        inputData: {
          ...prev.inputData,
          installation_items: updatedDetails,
        },
      };
    });
  };

  const handleAccessChange = (e, itemCode) => {
    const { name, checked } = e.target;

    setFormErrors((prevErrors) => {
      const newErrors = { ...prevErrors };

      if (newErrors.installation_items) {
        const updatedErrors = { ...newErrors.installation_items };

        if (updatedErrors[itemCode]) {
          delete updatedErrors[itemCode].commissioning_claim_remark;
        }

        newErrors.installation_items = updatedErrors;
      }
      return newErrors;
    });

    setFormData((prev) => {
      const updatedDetails = prev.inputData.installation_items?.map((item) => {
        if (item.item_code === itemCode) {
          const updatedItem = { ...item, [name]: checked };
          if (name === "is_commissioning_item_claimed" && !checked) {
            updatedItem.is_commissioning_item_paid = false;
          }
          return updatedItem;
        }
        return item;
      });

      return {
        ...prev,
        inputData: {
          ...prev.inputData,
          installation_items: updatedDetails,
        },
      };
    });
  };

  const handlePaymentAccessChange = (e, itemCode) => {
    const { name, checked } = e.target;

    setFormData((prev) => {
      const updatedDetails = prev.inputData.installation_items?.map((item) =>
        item.item_code === itemCode ? { ...item, [name]: checked } : item,
      );

      return {
        ...prev,
        inputData: {
          ...prev.inputData,
          installation_items: updatedDetails,
        },
      };
    });
  };

  const handleSubmit = async (e) => {
    try {
      const hasActiveItem = formData?.inputData?.installation_items?.some(
        (item) => item?.is_commissioning_item_claimed,
      );

      if (!hasActiveItem) {
        toast.error("At least one item must be active.");
        return;
      }
      const errors = {};

      // Validate required fields in invoice_order_items
      formData?.inputData?.installation_items?.forEach((row, index) => {
        if (row?.is_commissioning_item_claimed) {
          ["commissioning_claim_remark"].forEach((field) => {
            if (!row[field]?.toString().trim() || row[field] == "") {
              errors.installation_items = {
                ...errors.installation_items,
                [row.item_code]: {
                  ...errors.installation_items?.[row.item_code],
                  [field]: `${field.replace(/_/g, " ")} is required`,
                },
              };
            }
          });
        }
      });

      if (Object.keys(errors).length > 0) {
        setFormErrors(errors);
        return;
      }

      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      const userId = userDetails?.id || null;

      const transformedInstallationItems = {
        is_active: formData?.inputData?.is_active,
        installation_items:
          formData?.inputData?.installation_items?.map((item) => ({
            forceSave: true,
            id: item.installation_item_id,
            is_commissioning_item_claimed: item.is_commissioning_item_claimed,
            commissioning_claim_by: userId || item.commissioning_claim_by,
            commissioning_claim_remark: item.commissioning_claim_remark,
            commissioning_paid_by: userId || item?.commissioning_paid_by,
            is_commissioning_item_paid: item?.is_commissioning_item_paid,
          })) || [],
      };

      const payload = {
        id: formData?.inputData?.installation_id,
        checkAfterSave: true,
        actionType: "checkCommitioningClaimorPaid",
        modelName: "installations",
        relation: [
          {
            modelName: "installation_items",
            moduleAs: "installation_items",
            foreignKey: "installation_id",
            hooks: false,
          },
        ],
        inputData: transformedInstallationItems,
      };

      setLoadingData(true);
      const responseData = await saveRecords(payload, createEndpoint);

      if (responseData && responseData.code === 1) {
        toast.success(
          `${headerName} ${id ? "updated" : "saved"} successfully!`,
        );
        navigate(navigatePage?.back, { state: location.state });
      } else {
        throw new Error(
          responseData?.message ||
            `Error while ${id ? "updating" : "saving"} ${headerName}!`,
        );
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      toast.error(error.message || "An unexpected error occurred.");
    } finally {
      setLoadingData(false);
    }
  };
  const navigateBack = () => {
    if (location.state?.fromDashboard) {
      navigate("/dashboard");
    } else {
      navigate("/commissioning-claim-list", { state: location.state });
    }
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div style={formContentContainer}>
                    <AvForm className="needs-validation">
                      <div className="card mt-4">
                        <div className="card-header">
                          <h5>Commissioning Claim Details</h5>
                          <Button
                            style={{ marginLeft: "10px" }}
                            color="secondary"
                            className="waves-effect waves-light me-1 back-button"
                            onClick={navigateBack}
                          >
                            Back
                          </Button>
                          <Button
                            color="success"
                            className="waves-effect waves-light me-1 back-button ml-2"
                            style={{ borderRadius: "50%" }}
                            onClick={() =>
                              DownloadPDFData("InstallationApprovalDetails.pdf")
                            }
                          >
                            <i class="fas fa-download"></i>
                          </Button>
                        </div>
                        <div className="card-body">
                          <Row>
                            {/* First Section (Left Side) */}
                            <Col md="6">
                              <p>
                                <strong>Project Name: </strong>
                                {formData?.inputData ? (
                                  <span>
                                    {formData?.inputData?.project_name || "-"}
                                  </span>
                                ) : (
                                  "-"
                                )}
                              </p>
                              <p>
                                <strong>Commissioning No: </strong>
                                {formData?.inputData?.commissioning_no ? (
                                  <span>
                                    {formData?.inputData?.commissioning_no}
                                  </span>
                                ) : (
                                  "-"
                                )}
                              </p>
                              <p>
                                <strong>PO Number: </strong>
                                {formData?.inputData ? (
                                  <span>{formData?.inputData?.po_number}</span>
                                ) : (
                                  "-"
                                )}
                              </p>
                              <p>
                                <strong>Form Name: </strong>
                                {formData?.inputData ? (
                                  <span>{formData?.inputData?.form_name}</span>
                                ) : (
                                  "-"
                                )}
                              </p>
                              <p>
                                <strong>Field Name: </strong>
                                {formData?.inputData?.field_name ? (
                                  <span>{formData?.inputData?.field_name}</span>
                                ) : (
                                  "-"
                                )}
                              </p>
                              <p>
                                <strong>Commissioning Status: </strong>
                                <span className="text-uppercase">
                                  {formData?.inputData?.installation_status
                                    ? formData?.inputData
                                        ?.installation_status ===
                                      "commissioning_rejected"
                                      ? "Commissioning Rejected"
                                      : formData?.inputData
                                            ?.installation_status ===
                                          "commissioning_approved"
                                        ? "Commissioning Approved"
                                        : formData?.inputData
                                              ?.installation_status ===
                                            "commissioning_completed"
                                          ? "Commissioning Completed"
                                          : formData?.inputData
                                              ?.installation_status
                                    : "-"}
                                </span>
                              </p>

                              <p>
                                <strong>Status: </strong>
                                {formData?.inputData?.is_active
                                  ? "ACTIVE"
                                  : "IN-ACTIVE" || "-"}
                              </p>
                            </Col>

                            {/* Second Section (Right Side) */}
                            {/* <Col md="6" className="p-3">
                              <p>
                                <strong>Vehicle No: </strong>
                                {formData?.inputData?.vehical_no || "-"}
                              </p>

                              <p>
                                <strong>Remark: </strong>
                                {formData?.inputData?.remark || "-"}
                              </p>
                            </Col> */}
                          </Row>
                        </div>
                      </div>

                      <Row className="mt-4">
                        <div className="item-list-container">
                          <div className="d-flex justify-content-between align-items-center">
                            <h6 className="h-6-heading">Item Details</h6>
                            <div className="app-search d-flex d-lg-inline mt-0 p-0">
                              <div className="position-relative">
                                <input
                                  type="text"
                                  className="form-control ps-5"
                                  placeholder="Search by item code..."
                                  value={searchQuery}
                                  onChange={(e) =>
                                    setSearchQuery(e.target.value)
                                  }
                                  style={{
                                    width: "13rem",
                                    padding: "8px 15px",
                                    borderRadius: "8px",
                                    borderColor: "#D2D2D2",
                                    outline: "none",
                                    transition: "all 0.3s ease",
                                    boxShadow: "none",
                                    marginRight: "0.5rem",
                                  }}
                                />
                                <span className="ri-search-line"></span>
                              </div>
                            </div>
                          </div>
                          <div
                            className="table mt-2"
                            style={{
                              overflowX: "auto",
                              overflowY: "auto",
                              maxHeight: "500px",
                              width: "100%",
                              scrollBehavior: "smooth",
                              scrollbarWidth: "thin",
                              msOverflowStyle: "none",
                              zIndex: 0,
                            }}
                          >
                            <table className="table table-hover">
                              <thead
                                style={{
                                  position: "sticky",
                                  top: 0,
                                  backgroundColor: "#8AC1E8",
                                  zIndex: 1,
                                  overflow: "hidden",
                                }}
                              >
                                <tr style={{ borderBottom: "1px solid black" }}>
                                  <th style={{ whiteSpace: "nowrap" }}>
                                    Sr. No
                                  </th>
                                  <th
                                    style={{
                                      width: "18%",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Item Code
                                  </th>

                                  <th
                                    style={{
                                      width: "18%",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Item Description
                                  </th>
                                  <th
                                    style={{
                                      width: "15%",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    UOM
                                  </th>
                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                      width: "15%",
                                    }}
                                  >
                                    Required Qty
                                  </th>
                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                      width: "15%",
                                    }}
                                  >
                                    Assigned Qty
                                  </th>
                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                      width: "15%",
                                    }}
                                  >
                                    Installed Qty
                                  </th>

                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                      width: "18%",
                                    }}
                                  >
                                    Remark
                                  </th>
                                  <th
                                    style={{
                                      whiteSpace: "nowrap",
                                      width: "15%",
                                    }}
                                  >
                                    Claim
                                  </th>
                                  <th
                                    colSpan={4}
                                    style={{
                                      whiteSpace: "nowrap",
                                      width: "15%",
                                    }}
                                  >
                                    Payment
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {Object.values(groupedItems).length === 0 ? (
                                  <tr>
                                    <td
                                      colSpan="10"
                                      style={{ textAlign: "center" }}
                                    >
                                      No data available.
                                    </td>
                                  </tr>
                                ) : (
                                  Object.values(groupedItems).map(
                                    (group, index) => (
                                      <React.Fragment
                                        key={group.makeItem.unique_id}
                                      >
                                        {group.makeItem.is_make_item && (
                                          <tr
                                            style={{
                                              fontWeight: "bold",
                                              backgroundColor: "#f0f8ff",
                                            }}
                                          >
                                            <td>{serialNumber++}</td>
                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "180px",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  display: "-webkit-box",
                                                  WebkitBoxOrient: "vertical",
                                                  WebkitLineClamp: 2,
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  whiteSpace: "normal",
                                                }}
                                                title={
                                                  group.makeItem.item_code ||
                                                  "N/A"
                                                }
                                              >
                                                {group.makeItem.item_code ||
                                                  "N/A"}
                                              </div>
                                            </td>
                                            {/* <td>{"-"}</td> */}
                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "180px",
                                              }}
                                            >
                                              {" "}
                                              <div
                                                style={{
                                                  display: "-webkit-box",
                                                  WebkitBoxOrient: "vertical",
                                                  WebkitLineClamp: 2,
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  whiteSpace: "normal",
                                                }}
                                                title={
                                                  group?.makeItem
                                                    ?.make_item_desc || "N/A"
                                                }
                                              >
                                                {group?.makeItem
                                                  ?.make_item_desc || "N/A"}
                                              </div>
                                            </td>
                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "100px",
                                              }}
                                            >
                                              {" "}
                                              {group?.makeItem?.make_item_uom ||
                                                "N/A"}
                                            </td>
                                            <td>{"-"}</td>
                                            <td>{"-"}</td>
                                            <td>{"-"}</td>
                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "115px",
                                              }}
                                            >
                                              <TextAreaInput
                                                name="commissioning_claim_remark"
                                                onChange={(e) =>
                                                  handleItemDetailInputChange(
                                                    e,
                                                    group?.makeItem?.item_code,
                                                  )
                                                }
                                                value={
                                                  group?.makeItem
                                                    ?.commissioning_claim_remark
                                                }
                                                inputClassName="form-control"
                                                rows={1}
                                                cols={1}
                                                labelStyle={{ display: "none" }}
                                                placeholder="Remark"
                                                customError={
                                                  formErrors
                                                    ?.installation_items?.[
                                                    group?.makeItem?.item_code
                                                  ]
                                                    ?.commissioning_claim_remark ||
                                                  ""
                                                }
                                                disabled={
                                                  group?.makeItem
                                                    ?.is_commissioning_paid ===
                                                  true
                                                }
                                              />
                                            </td>
                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "5px",
                                              }}
                                            >
                                              <div className="d-flex gap-3 align-items-center">
                                                <CheckboxInput
                                                  name="is_commissioning_item_claimed"
                                                  value={
                                                    group?.makeItem
                                                      ?.is_commissioning_item_claimed
                                                  }
                                                  checked={
                                                    group?.makeItem
                                                      ?.is_commissioning_item_claimed
                                                  }
                                                  handleTextChange={(e) =>
                                                    handleAccessChange(
                                                      e,
                                                      group?.makeItem
                                                        ?.item_code,
                                                    )
                                                  }
                                                  parentClassName="form-check"
                                                  checkBoxClassName="form-check-input"
                                                  labelClassName="form-check-label"
                                                  labelStyle={{
                                                    display: "none",
                                                  }}
                                                  checkboxStyle={{
                                                    width: "18px",
                                                    height: "18px",
                                                  }}
                                                  disabled={
                                                    group?.makeItem
                                                      ?.is_commissioning_paid ===
                                                    true
                                                  }
                                                />
                                              </div>
                                            </td>
                                            <td
                                              colSpan="4"
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "5px",
                                              }}
                                            >
                                              <div className="d-flex gap-3 align-items-center">
                                                <CheckboxInput
                                                  name="is_commissioning_item_paid"
                                                  value={
                                                    group?.makeItem
                                                      ?.is_commissioning_item_paid
                                                  }
                                                  checked={
                                                    group?.makeItem
                                                      ?.is_commissioning_item_paid
                                                  }
                                                  handleTextChange={(e) =>
                                                    handlePaymentAccessChange(
                                                      e,
                                                      group?.makeItem
                                                        ?.item_code,
                                                    )
                                                  }
                                                  parentClassName="form-check"
                                                  checkBoxClassName="form-check-input"
                                                  labelClassName="form-check-label"
                                                  labelStyle={{
                                                    display: "none",
                                                  }}
                                                  checkboxStyle={{
                                                    width: "18px",
                                                    height: "18px",
                                                  }}
                                                  disabled={
                                                    group?.makeItem
                                                      ?.is_commissioning_item_claimed !==
                                                      true ||
                                                    group?.makeItem
                                                      ?.is_commissioning_paid ===
                                                      true
                                                  }
                                                />
                                              </div>
                                            </td>
                                          </tr>
                                        )}

                                        {group?.buyItems
                                          ?.filter((item) => item.is_make_item)
                                          ?.map((row, subIndex) => (
                                            <tr
                                              key={row.unique_id}
                                              style={{
                                                borderBottom: "1px solid #ccc",
                                              }}
                                            >
                                              <td>{`${serialNumber - 1}.${
                                                subIndex + 1
                                              }`}</td>
                                              {/* <td></td> */}
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "180px",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "-webkit-box",
                                                    WebkitBoxOrient: "vertical",
                                                    WebkitLineClamp: 2,
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "normal",
                                                  }}
                                                  title={
                                                    row?.buy_item_code || "N/A"
                                                  }
                                                >
                                                  {row?.buy_item_code || "N/A"}
                                                </div>
                                              </td>
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "180px",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "-webkit-box",
                                                    WebkitBoxOrient: "vertical",
                                                    WebkitLineClamp: 2,
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "normal",
                                                  }}
                                                  title={
                                                    row?.description || "N/A"
                                                  }
                                                >
                                                  {row?.description || "N/A"}
                                                </div>
                                              </td>
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "100px",
                                                }}
                                              >
                                                {row?.uom || "N/A"}
                                              </td>
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "100px",
                                                }}
                                              >
                                                {formatNumber(
                                                  row?.required_qty,
                                                ) || 0}
                                              </td>

                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "115px",
                                                }}
                                              >
                                                {row?.assigned_qty}
                                              </td>
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "115px",
                                                }}
                                              >
                                                {formatNumber(
                                                  row?.already_installed_qty ||
                                                    0,
                                                )}
                                              </td>

                                              <td colSpan={4}></td>
                                            </tr>
                                          ))}
                                        {group?.buyItems
                                          ?.filter(
                                            (item) =>
                                              item.is_make_item == false,
                                          )
                                          ?.map((row, subIndex) => (
                                            <tr
                                              key={row.unique_id}
                                              style={{
                                                borderBottom: "1px solid #ccc",
                                              }}
                                            >
                                              <td>{serialNumber++}</td>

                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "180px",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "-webkit-box",
                                                    WebkitBoxOrient: "vertical",
                                                    WebkitLineClamp: 2,
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "normal",
                                                  }}
                                                  title={
                                                    row?.item_code || "N/A"
                                                  }
                                                >
                                                  {row?.item_code || "N/A"}
                                                </div>
                                              </td>

                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "180px",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    display: "-webkit-box",
                                                    WebkitBoxOrient: "vertical",
                                                    WebkitLineClamp: 2,
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "normal",
                                                  }}
                                                  title={
                                                    row?.description || "N/A"
                                                  }
                                                >
                                                  {row?.description || "N/A"}
                                                </div>
                                              </td>
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "100px",
                                                }}
                                              >
                                                {row?.uom || "N/A"}
                                              </td>
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "100px",
                                                }}
                                              >
                                                {formatNumber(
                                                  row?.required_qty,
                                                )}
                                              </td>
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "100px",
                                                }}
                                              >
                                                {formatNumber(
                                                  row?.assigned_qty,
                                                )}
                                              </td>
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "100px",
                                                }}
                                              >
                                                {formatNumber(
                                                  row?.already_installed_qty,
                                                )}
                                              </td>

                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "2px",
                                                  minWidth: "115px",
                                                }}
                                              >
                                                <TextAreaInput
                                                  name="commissioning_claim_remark"
                                                  onChange={(e) =>
                                                    handleItemDetailInputChange(
                                                      e,
                                                      row?.item_code,
                                                    )
                                                  }
                                                  value={
                                                    row?.commissioning_claim_remark
                                                  }
                                                  inputClassName="form-control"
                                                  rows={1}
                                                  cols={1}
                                                  labelStyle={{
                                                    display: "none",
                                                  }}
                                                  placeholder="Remark"
                                                  customError={
                                                    formErrors
                                                      ?.installation_items?.[
                                                      row?.item_code
                                                    ]
                                                      ?.commissioning_claim_remark ||
                                                    ""
                                                  }
                                                  disabled={
                                                    row?.is_commissioning_paid ===
                                                    true
                                                  }
                                                />
                                              </td>
                                              <td
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "5px",
                                                }}
                                              >
                                                <div className="d-flex gap-3 align-items-center">
                                                  {" "}
                                                  <CheckboxInput
                                                    name="is_commissioning_item_claimed"
                                                    value={
                                                      row?.is_commissioning_item_claimed
                                                    }
                                                    checked={
                                                      row?.is_commissioning_item_claimed
                                                    }
                                                    handleTextChange={(e) =>
                                                      handleAccessChange(
                                                        e,
                                                        row?.item_code,
                                                      )
                                                    }
                                                    parentClassName="form-check"
                                                    checkBoxClassName="form-check-input"
                                                    labelClassName="form-check-label"
                                                    labelStyle={{
                                                      display: "none",
                                                    }}
                                                    checkboxStyle={{
                                                      width: "18px",
                                                      height: "18px",
                                                    }}
                                                    disabled={
                                                      row?.is_commissioning_paid ===
                                                      true
                                                    }
                                                  />
                                                </div>
                                              </td>
                                              <td
                                                colSpan="4"
                                                style={{
                                                  paddingLeft: "10px",
                                                  paddingRight: "5px",
                                                }}
                                              >
                                                <div className="d-flex gap-3 align-items-center">
                                                  {" "}
                                                  <CheckboxInput
                                                    name="is_commissioning_item_paid"
                                                    value={
                                                      row?.is_commissioning_item_paid
                                                    }
                                                    checked={
                                                      row?.is_commissioning_item_paid
                                                    }
                                                    handleTextChange={(e) =>
                                                      handlePaymentAccessChange(
                                                        e,
                                                        row?.item_code,
                                                      )
                                                    }
                                                    parentClassName="form-check"
                                                    checkBoxClassName="form-check-input"
                                                    labelClassName="form-check-label"
                                                    labelStyle={{
                                                      display: "none",
                                                    }}
                                                    checkboxStyle={{
                                                      width: "18px",
                                                      height: "18px",
                                                    }}
                                                    disabled={
                                                      row?.is_commissioning_item_claimed !==
                                                        true ||
                                                      row?.is_commissioning_paid ===
                                                        true
                                                    }
                                                  />
                                                </div>
                                              </td>
                                            </tr>
                                          ))}
                                      </React.Fragment>
                                    ),
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Row>

                      <Row>
                        <div className="d-flex justify-content-center flex-grow-1">
                          <Button
                            color="success"
                            style={{ height: "40px" }}
                            className="waves-effect waves-light me-1 back-button ml-2"
                            onClick={() => handleSubmit()}
                          >
                            Submit
                          </Button>
                        </div>
                      </Row>
                    </AvForm>
                    {/* Loader Overlay */}
                    {loadingData && (
                      <div style={loaderOverlay}>
                        <LoaderCreatePage />
                      </div>
                    )}
                  </div>
                  <div
                    style={{
                      display: "none",
                      position: "absolute",
                      left: "-9999px",
                    }}
                    id="pdfContent"
                  >
                    <CommissioningClaimPDF
                      data={formData.inputData}
                      groupedItems={groupedItems}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CommissioningClaimView;
